import type { NoteWords } from "@shared/unified-tiptap/extensions/date-annotation-note/date-annotation-note-extension"

/**
 * The note a user is part-way through writing in the Lesson Menu. The menu is a popover:
 * Escape backs out of it and a press outside closes it, either of which unmounts the editor
 * and would otherwise take the words with it.
 *
 * By class and day, so a draft can only come back to the day it was written for, and dropped
 * the moment the note is created or the class comes off without one.
 */
const drafts = new Map<string, NoteWords>()

export const noteDrafts = {
  key: (courseId: string, dateString: string) => `${courseId}:${dateString}`,

  read: (key: string): NoteWords => drafts.get(key) ?? { title: null, description: null },

  save(key: string, words: NoteWords) {
    drafts.set(key, words)
  },

  clear(key: string) {
    drafts.delete(key)
  },

  /** Test teardown: a draft outlives its menu on purpose, so it outlives a test too. */
  reset() {
    drafts.clear()
  },
}
